export default "__VITE_ASSET__DVPbZPao__"